import PropTypes from "prop-types";

export default PropTypes.shape({
  avatar: PropTypes.string,
  company: PropTypes.string,
  id: PropTypes.number,
  name: PropTypes.string,
});
